import { lazy } from 'react';

export const InviteVipPlayersForm = lazy(
  () => import('./InviteVipPlayersForm'),
);
